/**
 * Report next step status.
 */
export enum NextStepStatus {
  OlderWorkOrder,
  NewWorkOrder,
  CreatedWorkOrder,
}
